import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Resolves the shipper company name for a private LR Direct network.
 * Backed by the get_network_shipper_name SECURITY DEFINER RPC, which
 * returns the real company name to accepted network members and
 * "Private Network" otherwise.
 */
export function useNetworkShipperName(networkId: string | null | undefined) {
  return useQuery({
    queryKey: ["lr-direct", "network-shipper-name", networkId],
    queryFn: async () => {
      if (!networkId) return "Private Network";
      const { data, error } = await supabase.rpc("get_network_shipper_name", {
        _network_id: networkId,
      });
      if (error) {
        console.warn("get_network_shipper_name failed:", error.message);
        return "Private Network";
      }
      return (data as string | null) ?? "Private Network";
    },
    enabled: !!networkId,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}
